/**
 * Application route paths.
 * Use these constants in `<Link to={PATHS.xxx}>` and `navigate(PATHS.xxx)`.
 * Parametric routes expose a helper: `PATHS.xxxTo({ param })`.
 */

export const PATHS = {
  /* Public */
  home: "/",
  mobileLogin: "/mobile-login",
  mobileRegistration: "/mobile-registration",
  /* Auth */
  authLogin: "/auth/login",
  authRegister: "/auth/register",
  authRecover: "/auth/recover",
  /* Wallet */
  wallet: "/wallet",
  depositPagoMovil: "/wallet/deposit/pago-movil",
  withdrawalPagoMovil: "/wallet/withdrawal/pago-movil",
  transfer: "/wallet/transfer",
  /* User area */
  userProfile: "/user/profile",
  userContacts: "/user/contacts",
  userPagoMovil: "/user/pago-movil",
  userTransactions: "/user/transactions",
  userReferrals: "/user/referrals",
  /* Lottery (v2 landing, legacy sub-routes still mounted at /lottery/:category etc.) */
  lotteryV2: "/lottery/v2",
  /* Raffles */
  raffles: "/raffles",
  rafflesTickets: "/raffles/tickets",
  /* News */
  news: "/news",
  article: "/article/:slug",

  termsAndConditions: "/terminos-y-condiciones",
  deleteAccount: "/eliminar-cuenta",
  paykuCallback: "/payku/callback",

  /* Games */
  games: "/games",
  gamesListAll: "/gameslist/all",
  gamesByCategory: "/games/category/:category",
  gamesByProvider: "/games/provider/:provider",
  gameById: "/games/:provider/:gameId",
  casino: "/casino",
  liveCasino: "/live-casino",
  sports: "/sports",
  bingo: "/bingo",
  horses: "/horses",
  gameFeed: "/game-feed",
  providerLanding: "/provider/:provider",

  /* Lottery (legacy sub-routes) */
  lottery: "/lottery",
  lotteryCategory: "/lottery/:category",
  lotteryGame: "/lottery/:gameIdString",
  lotteryResults: "/lottery/:gameId/results",
  lotteryTickets: "/lottery/tickets",

  /* Lotoven */
  lotoven: "/lotoven",
  lotovenHome: "/lotoven/home",
  lotovenAnimalitos: "/lotoven/animalitos",
  lotovenLoterias: "/lotoven/loterias",
} as const;

export type PathKey = keyof typeof PATHS;

/* ---- Parametric URL builders ---- */

export const pathTo = {
  gamesByCategory: (category: string) => `/games/category/${encodeURIComponent(category)}`,
  gamesByProvider: (provider: string) => `/games/provider/${encodeURIComponent(provider)}`,
  gameById: (provider: string, gameId: string) =>
    `/games/${encodeURIComponent(provider)}/${encodeURIComponent(gameId)}`,
  lotteryCategory: (category: string) => `/lottery/${encodeURIComponent(category)}`,
  lotteryGame: (gameIdString: string) => `/lottery/${encodeURIComponent(gameIdString)}`,
  lotteryResults: (gameId: string) => `/lottery/${encodeURIComponent(gameId)}/results`,
  providerLanding: (provider: string) => `/provider/${encodeURIComponent(provider)}`,
  article: (slug: string) => `/article/${encodeURIComponent(slug)}`,
} as const;
